import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { PublicRoute } from './PublicRoute';
import { AppShell } from '@/components/layout/AppShell';

// Auth Pages
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { RegisterPage } from '@/features/auth/pages/RegisterPage';
import { AcceptInvitePage } from '@/features/auth/pages/AcceptInvitePage';

// Main Application Pages
import { ConversationsPage } from '@/features/conversations/pages/ConversationsPage';
import { CustomersPage } from '@/features/customers/pages/CustomersPage';
import { IntegrationsPage } from '@/features/integrations/pages/IntegrationsPage';
import { OAuthCallbackPage } from '@/features/integrations/pages/OAuthCallbackPage';
import { ProfilePage } from '@/features/profile/pages/ProfilePage';
import { BillingPage } from '@/features/billing/pages/BillingPage';
import { TeamPage } from '@/features/team/pages/TeamPage';
import { NoWorkspacesPage } from '@/features/workspaces/pages/NoWorkspacesPage';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Guest-only Auth Routes */}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
      </Route>

      {/* Invitation Routes: Accessible by both logged-in users and guests */}
      <Route path="/invitations/:token" element={<AcceptInvitePage />} />
      <Route path="/invite/accept" element={<AcceptInvitePage />} />

      {/* Mixed / Public Routes that don't need AppShell */}
      <Route path="/oauth/:provider/callback" element={<OAuthCallbackPage />} />

      {/* Protected Standalone Routes (e.g. Empty Workspace State) */}
      <Route element={<ProtectedRoute />}>
        <Route path="/no-workspaces" element={<NoWorkspacesPage />} />
      </Route>

      {/* Protected Application Shell Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<Navigate to="/conversations" replace />} />
          <Route path="/conversations" element={<ConversationsPage />} />
          <Route path="/conversations/:conversationId" element={<ConversationsPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/preferences" element={<Navigate to="/integrations" replace />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/billing/success" element={<BillingPage />} />
        </Route>
      </Route>

      {/* Catch-all fallback */}
      <Route path="*" element={<Navigate to="/conversations" replace />} />
    </Routes>
  );
};

export default AppRoutes;

